import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Opinion } from '../../shared/interfaces/opinion';
import { FAQ } from '../../shared/interfaces/faq';
import { IProduct } from '../../shared/interfaces/IProduct';
import { IRegisterForm } from '../../shared/interfaces/IRegisterForm';
import { AuthResponse } from '../../shared/interfaces/auth-response';
import { IPurchaseForm } from '../../shared/interfaces/IPurchaseForm';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  private apiUrl = environment.apiUrl;
  private productsForSubs: IProduct[] = [];

  constructor(private httpClient: HttpClient) {}

  getOpinions(): Observable<Opinion[]> {
    return this.httpClient.get<Opinion[]>(`${this.apiUrl}opinions`);
  }
  getMetWays(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}metWays`);
  }
  getFaqs(): Observable<FAQ[]> {
    return this.httpClient.get<FAQ[]>(`${this.apiUrl}faqs`);
  }
  getProducts(zipCode): Observable<IProduct[]> {
    console.log(zipCode);
    let parameters = '';
    if (zipCode) {
      parameters = `?zipCode=${zipCode}`;
    }

    return this.httpClient
      .get<IProduct[]>(`${this.apiUrl}landing/products${parameters}`)
      .pipe(catchError(this.handleError));
  }
  getProduct(id: number, zipCode?, periodicity?): Observable<IProduct> {
    let parameters = '';
    if (zipCode) {
      parameters = `?zipCode=${zipCode}`;
    }
    if (periodicity) {
      if (parameters.length > 0) {
        parameters = `${parameters}&periodicity=${periodicity}`;
      } else {
        parameters = `?periodicity=${periodicity}`;
      }
    }
    return this.httpClient
      .get<IProduct>(`${this.apiUrl}landing/product/${id}${parameters}`)
      .pipe(catchError(this.handleError));
  }
  registerUser(data: IRegisterForm): Observable<AuthResponse> {
    return this.httpClient.post<AuthResponse>(`${this.apiUrl}register`, data);
  }
  updateUser(
    userId: number,
    formData: any,
    empresaSelect: boolean
  ): Observable<any> {
    const fullName = empresaSelect
      ? formData.first_name
      : `${formData.last_name.toUpperCase()}, ${formData.first_name.toUpperCase()}`;

    formData.person_type =
      formData.person_type === 'after' ? 'PERSONA FISICA' : 'EMPRESA';

    let dataToUpdate = {
      name: fullName,
      document: formData.document,
      phone: formData.phone,
      gender: formData.gender,
      iva_exempt: formData.iva_exempt,
      person_type: formData.person_type,
      password: formData.password,
    };

    return this.httpClient
      .put<any>(`${this.apiUrl}clients/update/${userId}`, dataToUpdate)
      .pipe(catchError(this.handleError));
  }
  requestSubscription(data: IPurchaseForm): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}requestSubscription`, data);
  }
  verifyScore(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .post<any>(`${this.apiUrl}subscription/verify`, data)
        .subscribe((res) => {
          resolve(res);
        }, reject);
    });
  }
  getScore(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient
        .post<any>(`${this.apiUrl}get/verify`, data)
        .subscribe((res) => {
          resolve(res);
        }, reject);
    });
  }
  private handleError(error: Response) {
    console.log(error);
    const msg = 'Error Codigo' + error.status + 'Estado' + error.statusText;
    return throwError(msg);
  }

  //diego, agregue este metodo para calcular el precio sin iva para ventas, como se usa en varios lugares lo puse aca
  priceWithoutIva(product: IProduct): number {
    if (!product.periodicity || product.periodicity.length === 0) {
      return 0;
    }

    // Para suscripciones, buscar la periodicidad mensual (igual que en getPrice)
    const monthly = product.periodicity.find((item) => item.months >= 1);
    if (monthly) {
      const periodicPrice = monthly.pivot?.periodic_price || 0;
      return periodicPrice / 1.21;
    }

    // Fallback: si no hay periodicidad mensual, tomar la primera disponible
    const firstPeriodicity = product.periodicity[0];
    const periodicPrice = firstPeriodicity.pivot?.periodic_price || 0;
    return periodicPrice / 1.21;
  }

  cancelShipnowOrder(orderId: number): Promise<any> {
    let data = { id: orderId };
    return new Promise((resolve, reject) => {
      this.httpClient
        .post<any>(`${this.apiUrl}subscription/cancelShipnowOrder`, data)
        .subscribe((res) => {
          resolve(res);
        }, reject);
    });
  }

  validateCoupon(code: string): Observable<any> {
    return this.httpClient.post<any>(
      `${this.apiUrl}discounts/validate-coupon`,
      { code }
    );
  }

  checkZipCode(zip_code: string): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}zip-code/check`, {
      zip_code,
    });
  }

  setProducts(productsForSubs: IProduct[]): void {
    this.productsForSubs = productsForSubs;
  }

  getproductsForSubs(): IProduct[] {
    return this.productsForSubs;
  }
}
